import React from 'react';
import { CSSObject } from '@emotion/react';
import BlockHeader from '@cvent/blocks/components/BlockHeader';
import { useTranslate } from 'nucleus-text';
import useBreakpoints from '@hooks/useBreakpoints';

interface InfoPageHeaderProps {
  subheader?: JSX.Element;
  title: string;
  isCancelled?: boolean;
}

const useStyles = (): Record<string, CSSObject> => {
  const breakpoints = useBreakpoints();
  const { mediaIsM, mediaIsXL, mediaIsLargeAndAbove } = breakpoints;

  return {
    headerText: {
      marginTop: 0,
      fontSize: 30,
      marginBottom: 16,
      [mediaIsM]: {
        fontSize: 36
      },
      [mediaIsXL]: {
        fontSize: 40
      },
      [mediaIsLargeAndAbove]: {
        marginBottom: 24
      }
    }
  };
};

function InfoPageHeader({ isCancelled, subheader, title }: InfoPageHeaderProps): JSX.Element {
  const { headerText } = useStyles();
  const { translate } = useTranslate();

  return (
    <BlockHeader css={headerText} textAlign="left" subtext={isCancelled ? null : subheader}>
      <>{isCancelled ? translate('Event-Canceled-Text', { eventName: title }) : title}</>
    </BlockHeader>
  );
}

export default InfoPageHeader;
